<template>
    <path d="M14.131 6.307a3.743 3.743 0 0 1 1.742 2.781 3.021 3.021 0 1 0-1.742-2.781zm-1.98 6.186a3.021 3.021 0 1 0 .001-6.042 3.021 3.021 0 0 0 0 6.042zm1.283.206H10.87A3.873 3.873 0 0 0 7 16.57v3.134l.008.05.216.067c2.036.636 3.804.848 5.26.848 2.843 0 4.491-.81 4.593-.862l.202-.102h.021v-3.136a3.872 3.872 0 0 0-3.867-3.869zm4.998-3.119h-2.544a3.723 3.723 0 0 1-1.149 2.594 4.597 4.597 0 0 1 3.283 4.399v.966c2.512-.092 3.96-.804 4.055-.852l.202-.102h.021v-3.136a3.873 3.873 0 0 0-3.868-3.869zM6.85 9.375c.592 0 1.141-.173 1.607-.467a3.74 3.74 0 0 1 1.406-2.384c.003-.057.008-.113.008-.17a3.021 3.021 0 1 0-3.02 3.02zm2.714 2.799a3.726 3.726 0 0 1-1.149-2.58c-.094-.006-.187-.014-.283-.014H5.568A3.873 3.873 0 0 0 1.7 13.45v3.135l.008.049.216.068c1.633.51 3.09.745 4.356.819v-.947a4.598 4.598 0 0 1 3.284-4.4z"/>
</template>

<script>
    export default {
        name: 'user-group',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/UserGroup.vue